<template>
    <div id="app">
        <loader></loader>
        <router-view/>
    </div>
</template>

<script>
    import Loader from './components/layout/Loader'
    export default {
        name: 'App',
        components: {
            Loader
        }
    }
</script>


// WEBPACK FOOTER //
// src/App.vue